module.exports = __webpack_public_path__ + "static/media/stonks_orange.412c26ea.svg";